import { type OverlayTriggerState } from "@react-stately/overlays";
import { type FC, type ReactNode, useRef } from "react";
import { type AriaPopoverProps, DismissButton, Overlay, usePopover } from "react-aria";

export const CalendarPopover: FC<
	Omit<AriaPopoverProps, "popoverRef"> & {
		state: OverlayTriggerState;
		children: ReactNode;
		withPortal: boolean;
	}
> = (props) => {
	const ref = useRef<HTMLDivElement>(null);
	const { state, children, withPortal } = props;

	const { popoverProps /*underlayProps*/ } = usePopover({ ...props, popoverRef: ref }, state);

	const content = (
		<>
			{/*
			FIXME: Underlay blocks clicking on the "clear date" button in DataGrid v3. I'm not sure
			when it's helpful or required, though, and the examples seem to use it sporadically.
			*/}
			{/* <div {...underlayProps} className="fixed inset-0" /> */}
			<div
				{...popoverProps}
				ref={ref}
				className="absolute z-popover my-2 rounded-md bg-primary p-6 text-sm shadow-border-dropshadow-default pointer-events-auto"
			>
				<DismissButton onDismiss={state.close} />
				{children}
				<DismissButton onDismiss={state.close} />
			</div>
		</>
	);

	return withPortal ? <Overlay>{content}</Overlay> : content;
};
